<template>
  <div>
    <v-card>
      <v-layout pt-3 row justify-center align-center>
          <v-flex class="ma-2" xs12>
            <table width="95%">
              <thead>
                <tr>
                  <th align="center">{{ $t('extracurriculares.courses.form.type') }}</th>
                  <th align="center">{{ $t('extracurriculares.courses.form.name') }}</th>
                  <th align="center">{{ $t('extracurriculares.courses.teachers_modal.schedule') }}</th>
                  <th align="center"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(course_register, ci) in detail" :key="ci">
                  <td align="center">{{ course_register.course.course_type.name }}</td>
                  <td v-if="locale == 'es'" align="center">{{ course_register.course.name }}</td>
                  <td v-else align="center">{{ course_register.course.eng_name }}</td>
                  <td align="center">{{ course_register.schedule.name }}</td>
                  <td align="center">
                    <v-btn
                    @click="discartCourse(course_register.id)"
                      :disabled="!(!course_register.payment || (course_register.payment && paymentFailed(course_register.payment.payment_state)))"
                      color="error">
                      {{ $t('extracurriculares.courses.form.cancel') }}</v-btn>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  export default {
    name: 'register-detail-view',
    props: {
      detail: {
        type: Array,
        required: true
      },
    },
    computed: mapGetters({
      locale: 'locale'
    }),
    methods: {
      paymentFailed(payment_state) {
        return payment_state === 'FAILED' ||
                payment_state === 'NOT_AUTHORIZED' ||
                payment_state === 'REJECTED' ||
                payment_state == '0'
      },
      discartCourse(enrollment_course_id) {
        axios.delete(`/api/extracurriculares/course/register/${enrollment_course_id}`)
          .then(resp => {
            if (resp.status === 200) {
              if (this.$store.getters.authUser.id_user_type === 2) {
                this.$store.dispatch('fetchPaymentData')
                this.$store.dispatch('fetchRegisteredCourses')
                this.$store.dispatch('fetchStudents')
              } else {
                this.$store.dispatch('fetchExtPaymentData')
                this.$store.dispatch('fetchExtRegisteredCourses')
              }
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      formatNumber(number) {
        if(!number || typeof number === 'undefined') {
            return 0;
        } else {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/enrollment/register_detail.vue